import { render, staticRenderFns } from "./StatisticsVersion.vue?vue&type=template&id=3ee90809"
import script from "./StatisticsVersion.vue?vue&type=script&lang=js"
export * from "./StatisticsVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports